import { createBurstGesture } from './burstFactory.js';
export default createBurstGesture('up');
